const DEFAULT_MEDIA_TYPE = '1'

const MEDIA_TYPE_OPTIONS = [
  {
    id: 'tsc_radio',
    name: 'tscRadio',
    value: '1',
    translationKey: 'tsc',
    icon: 'point-of-sale'
  },
  {
    id: 'qr_radio',
    name: 'qrRadio',
    value: '2',
    translationKey: 'qr',
    icon: 'qr'
  }
]

export {
  DEFAULT_MEDIA_TYPE,
  MEDIA_TYPE_OPTIONS
}
